import React from 'react'
import { Route } from 'react-router-dom'
import Login from '../Login/Login'

type LoginLayoutRouteProps = any

const LoginLayoutRoute = ({ ...rest }: LoginLayoutRouteProps): React.ReactElement => <Route {...rest} render={() => <Login />} />

export default LoginLayoutRoute
